<template>
    <div class="message">
        <Form :label-width="100">
            <FormItem :label="$t('pikai_img')">
                <div class="image-section">
                  <img
                    v-model="formItem.pikai_img"
                    v-if="formItem.pikai_img"
                    :src="formItem.pikai_img"
                    class="card-image"
                    @click="identityFrontChooseImage"
                  />
                  <div
                    v-else
                    class="upload-area"
                    @click="identityFrontChooseImage"
                  >
                    <div class="upload-placeholder">
                      <span class="plus-icon">+</span>
                      <span>{{ $t('coin.new_upload') }}</span>
                    </div>
                  </div>
                </div>
            </FormItem>
            <FormItem :label="$t('pikai_title_cn')">
                <Input v-model="formItem.pikai_title_cn"></Input>
            </FormItem>
            <FormItem :label="$t('pikai_title_en')">
                <Input v-model="formItem.pikai_title_en"></Input>
            </FormItem>
            <FormItem :label="$t('pikai_title_lao')">
                <Input v-model="formItem.pikai_title_lao"></Input>
            </FormItem>
            <FormItem :label="$t('xinnengyuan_img')">
                <div class="image-section">
                  <img
                    v-model="formItem.xinnengyuan_img"
                    v-if="formItem.xinnengyuan_img"
                    :src="formItem.xinnengyuan_img"
                    class="card-image"
                    @click="identityBackChooseImage"
                  />
                  <div
                    v-else
                    class="upload-area"
                    @click="identityBackChooseImage"
                  >
                    <div class="upload-placeholder">
                      <span class="plus-icon">+</span>
                      <span>{{ $t('coin.new_upload') }}</span>
                    </div>
                  </div>
                </div>
            </FormItem>
            <FormItem :label="$t('xinnengyuan_title_cn')">
                <Input v-model="formItem.xinnengyuan_title_cn"></Input>
            </FormItem>
            <FormItem :label="$t('xinnengyuan_title_lao')">
                <Input v-model="formItem.xinnengyuan_title_en"></Input>
            </FormItem>
            <FormItem :label="$t('xinnengyuan_title_lao')">
                <Input v-model="formItem.xinnengyuan_title_lao"></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="doPost">{{$t('submit')}}</Button>
                <!--Button style="margin-left: 8px">{{$t('cancel')}}</Button-->
            </FormItem>
        </Form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formItem: {
              pikai_img: "",
              pikai_title_cn: "",
              pikai_title_en: "",
              pikai_title_lao: "",
              xinnengyuan_img: "",
              xinnengyuan_title_cn: "",
              xinnengyuan_title_en: "",
              xinnengyuan_title_lao: ""
            }
        };
    },
    mounted(){
        this.loadData();
    },
    methods: {
        doPost() {
            console.log(this.formItem);
            this.$post(this.$path.zhuanqu, {
              pikai_img: this.formItem.pikai_img,
              pikai_title_cn: this.formItem.pikai_title_cn,
              pikai_title_en: this.formItem.pikai_title_en,
              pikai_title_lao: this.formItem.pikai_title_lao,
              xinnengyuan_img: this.formItem.xinnengyuan_img,
              xinnengyuan_title_cn: this.formItem.xinnengyuan_title_cn,
              xinnengyuan_title_en: this.formItem.xinnengyuan_title_en,
              xinnengyuan_title_lao: this.formItem.xinnengyuan_title_lao
            }).then(res => {
                if (res.success) {
                    this.$Message.success('修改成功');
                } else {
                    this.$Message.error('修改失败');
                    console.error(res);
                }
            });
        },
        loadData() {
            this.$get(this.$path.zhuanqu, {

            }).then(res => {
                if (res.data) {
                  console.log(res.data[0]);
                    this.formItem = res.data[0];
                } else {
                    this.$Message.error('获取数据失败');
                }
            });
        },
        async identityFrontChooseImage() {
          try {
            // 创建文件输入元素
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = 'image/*'

            input.onchange = async (event) => {
              const file = event.target.files[0]
              if (file) {
                await this.uploadImage(file, 0);
              }
            }

            input.click()
            this.showPopup = false
          } catch (error) {
            console.error(error)
          }
        },
        async identityBackChooseImage() {
          try {
            // 创建文件输入元素
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = 'image/*'

            input.onchange = async (event) => {
              const file = event.target.files[0]
              if (file) {
                await this.uploadImage(file, 1);
              }
            }

            input.click()
            this.showPopup = false
          } catch (error) {
            console.error(error)
          }
        },
        /**
         * 上传文件处理
         */
        async uploadImage(file, type) {
            const formData = new FormData()
            formData.append('img', file)
            //this.$toast.showLoading(this.$t('mine.introduce.loading'))
            this.$file(this.$path.upload, formData)
            .then(async res => {
              //this.$toast.hideLoading();
              if (res.success === true) {
                if(type == 0){
                  this.formItem.pikai_img = (this.$path.ip + res.data.path)
                }else{
                  this.formItem.xinnengyuan_img = (this.$path.ip + res.data.path)
                }
                console.log(this.formItem);
              }else{

              }
            })
            .catch(err => {
              //this.$toast.hideLoading();
            })
        },
    }
};
</script>
<style lang="scss" scoped>
.image-section {
  margin-top: 10px;
  width: 120px;
  height: 120px;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.image-item {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  overflow: hidden;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.image-actions {
  position: absolute;
  top: 2px;
  right: 2px;
  display: flex;
  align-items: center;
}

.delete-icon {
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  font-size: 14px;
}

.delete-icon:hover {
  background: rgba(255, 0, 0, 0.7);
}

.image-index {
  background: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 4px;
}

.upload-area {
  width: 100px;
  height: 100px;
  border: 1px dashed #dcdee2;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #fafafa;
}

.upload-area:hover {
  border-color: #409eff;
  background: #ecf5ff;
}

.upload-placeholder {
  text-align: center;
  color: #8c8c8c;
}

.plus-icon {
  font-size: 24px;
  color: #409eff;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/system/level.vue